import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-horizontal-view",
  "use": "icon-horizontal-view-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-horizontal-view\">\n<rect x=\"6\" y=\"13\" width=\"12\" height=\"6\" rx=\"1\" stroke=\"#B5BBC5\" stroke-width=\"2\" />\n<rect x=\"6\" y=\"5\" width=\"4\" height=\"4\" rx=\"1\" stroke=\"#42526E\" stroke-width=\"2\" />\n<rect x=\"14\" y=\"5\" width=\"4\" height=\"4\" rx=\"1\" stroke=\"#42526E\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol